import { lazy, Suspense, useEffect } from "react";
import Banner from "../components/Banner.js";
const Calculator = lazy(() => import("../components/Calculator.js"));
const Benefits = lazy(() => import("../components/Benefits.js"));
const Faq = lazy(() => import("../components/Faq.js"));
const MortgageLoans = lazy(() => import("../components/MortgageLoans.js"));
const Footer = lazy(() => import("../components/Footer.js"));

function Homepage() {
  useEffect(() => {}, []);

  return (
    <>
      {/* <Header /> */}
      <Suspense fallback={<>Loading...</>}>
        <Banner />
        <Calculator />
        <Benefits />
        <MortgageLoans />
        <Faq />
        <Footer />
      </Suspense>
    </>
  );
}

export default Homepage;
